<div class="bk-dialog bk-dialog__event">
	<button class="bk-modal__close_btn"
		(click)="close()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>

	<h4 mat-dialog-title>
		<ng-container *ngIf="data && data.Id"
			class="bk-modal__header-title">
			{{'Edit' | translate }} {{'Lot' | translate }}
		</ng-container>
		<ng-container *ngIf="!data || !data.Id"
			class="bk-modal__header-title">
			{{'Add' | translate }} {{'Lot' | translate }}
		</ng-container>
	</h4>

	<ranch-lot-form
		[id]="data ? data.Id : null"
		[ranchCoordinates]="data ? data.RanchCoordinates : null"
		(onCancel)="close()"
		(onDelete)="delete()"
		(onHide)="hide()"
		(onShow)="show()"
		(onSubmit)="submit($event)">
	</ranch-lot-form>
</div>
